//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from "vuex-pathify"

export default {
  data() {
    return {
      respuesta_correcta: null,
      frase: null,
      respuestas: [{}],
    }
  },

  computed: {
    examen: get("examen/seleccion"),
  },

  methods: {
    async submit() {
      const pregunta = await this.$store.dispatch("examen/pregunta/add", {
        examen: this.examen.id,
        pregunta: {
          frase: this.frase,
          respuestas: this.respuestas,
        },
      })
      this.$emit("submit", pregunta)
    },

    addRespuesta() {
      this.respuestas.push({})
    },

    setRespuestaCorrecta(respuesta, index) {
      this.respuestas = this.respuestas.map((e) => {
        e.es_correcta = false

        return e
      })
      respuesta.es_correcta = true
      console.log(this.respuestas)
    },
    removeRespuesta(respuesta, index) {
      this.respuestas = this.respuestas.filter((e, i) => i != index)
    },
  },
}
